// @ vendors
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const gdprConsentsActions = require('actions/gdprConsents');

// @actions
const {
    hireContractFailure,
    hireContractSuccess,
} = require('actions/contracts');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const signaturePatternActions = require('actions/signaturePattern');

const {
    ACCOUNT_INTERVENTION_OWNER_CODE,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_STANDARD,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA_CC,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE,
} = require('constants/index');

const depositHireInformationIsFetching = isAccountChange => ({
    type: actionTypes.CONTRACT_METHOD_18_MONTHS_DEPOSIT_GET_DATA_IS_FETCHING,
    payload: {
        isAccountChange
    }
});

const depositHireInformationSuccess = response => ({
    type: actionTypes.CONTRACT_METHOD_18_MONTHS_DEPOSIT_GET_DATA_SUCCESS,
    payload: {
        response
    }
});

const depositHireInformationFailure = errorBody => ({
    type: actionTypes.CONTRACT_METHOD_18_MONTHS_DEPOSIT_GET_DATA_FAILURE,
    payload: {
        errorBody
    }
});

const requestDepositEighteenHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_HIRE_CONFIRMATION_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE,
            subProducto: __CONTACT_CENTER__ ?
                DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA_CC :
                DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};

const refreshDepositEighteenHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDepositEighteenHireInformation(immAccount, interveners, true));
};


const setDepositEighteenMonths = (dispatch, data, getState) => {
    const requestData = {
        header: {
            version: 2
        },
        query: data,
    };
    const immContracts = getState().contracts;
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    return APIPost(dispatch, apiURLBuilder.getURL('hireDepositConfirmation'), requestData)
        .then(response => {
            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData));
        })
        .catch(response => {
            if (response.error) {
                dispatch(hireContractFailure(response.error));
            } else {
                throw response;
            }
        });
};

const hireDepositEighteenMonths = params => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const data = Object.assign(params, { dataToken });
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setDepositEighteenMonths(dispatch, data, getState))
            .catch(response => {
                if(!!response.error) {
                    setDepositEighteenMonths(dispatch, data, getState);
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireDepositEighteenMonths,
    refreshDepositEighteenHireInformation,
    requestDepositEighteenHireInformation,
};
